export const LOGOUT_BEGIN = 'LOGOUT_BEGIN';
export const CHANGE_TIME = 'CHANGE_TIME';
export const LOGOUT_END = 'LOGOUT_END';
export const SIDEDRAWER_OPEN = 'SIDEDRAWER_OPEN';
export const SIDEDRAWER_CLOSE = 'SIDEDRAWER_CLOSE';

